import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const notificationList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.get('/notification/list', {
    pageSize: pageSize,
    pageNumber: pageNumber,
    ...query,
  });
};

export const notificationSummary = (params) => {
  return _baseClient.get('/notification/summary', params);
};

export const notificationRead = (params) => {
  return _baseClient.post('/notification/read', { body: params });
};

export const notificationUnreadCount = (params) => {
  return _baseClient.get('/notification/get-unread-count', params);
};
